<template>
    <main>
        <Head>
            <title>{{ category.meta_title }}</title>
            <meta name="description" :content="category.meta_description" inertia="description" />
        </Head>

        <div v-if="showResource" class="bg-red-500/10 text-red-500 text-center my-4 py-2 rounded-md mx-auto max-w-2xl">
            Categorie is uitgeschakeld.
        </div>

        <div class="w-full bg-gray-50">
            <!-- Admin edit links -->
            <div
                class="flex justify-end relative max-w-(--breakpoint-2xl) mx-auto space-x-2"
                v-if="user && user.is_admin && [30, 25, 33595].includes(user.id)"
            >
                <div class="flex items-center space-x-2 absolute right-8 top-3">
                    <a
                        target="_blank"
                        :href="`https://nv.doorax.nl/nova-beheer/resources/categories/${category.id}/edit`"
                        class="text-xs text-gray-500 hover:text-gray-700 border border-orange-500 rounded-md px-2 py-1"
                    >
                        <fa :icon="['fal', 'pencil']" class="h-3 w-3" />
                        Nova
                    </a>
                    <a
                        target="_blank"
                        :href="`https://content.doorax.nl/category-find/${category.id}`"
                        class="text-xs text-gray-500 hover:text-gray-700 border border-blue-500 rounded-md px-2 py-1"
                    >
                        <fa :icon="['fal', 'pencil']" class="h-3 w-3" />
                        Content
                    </a>
                </div>
            </div>

            <div class="max-w-(--breakpoint-2xl) container mx-auto px-4 md:px-8 pt-4">
                <!-- Breadcrumbs -->
                <Breadcrumbs />

                <div class="py-2">
                    <div
                        class="d-prose my-1 text-base text-gray-500 md:h-auto relative"
                        :class="{ 'overflow-hidden md:overflow-visible': !showMore }"
                    >
                        <div class="flex flex-wrap" v-if="category.id == 1 || category.catalog_id == 1">
                            <div class="w-full md:w-3/4">
                                <div class="flex flex-col">
                                    <h1>
                                        {{ category.title }}
                                    </h1>
                                    <div
                                        class="m:pr-12 flex justify-center flex-col items-center"
                                        :class="{ 'pr-20': !showMore }"
                                    >
                                        <p
                                            v-html="category.description"
                                            class=""
                                            :class="{ 'line-clamp-2 md:line-clamp-none': !showMore }"
                                        ></p>
                                    </div>
                                </div>
                            </div>
                            <div class="hidden md:block relative md:w-1/4 z-10">
                                <div
                                    class="rounded-lg shadow-xl border-dgreen2/50 p-4 bg-white flex flex-col relative mb-2"
                                >
                                    <strong class="text-lg text-gray-900 mb-4">Keuzehulp</strong>
                                    <div class="w-1/2 grow mb-8">In 4 stappen de beste cilinder voor jou.</div>
                                    <div class="absolute right-8 bottom-12">
                                        <vue-picture
                                            class="hidden md:block"
                                            :image="{
                                                src: asset('img/kevin-cilinder-keuzehulp.webp'),
                                                origin_src: asset('img/kevin-cilinder-keuzehulp.png'),
                                            }"
                                            name="Kevin cilinder keuzehulp"
                                            :notlazy="true"
                                            :width="100"
                                            :height="177"
                                        />
                                    </div>
                                    <button @click="showWizard" class="button dgreen w-full relative">
                                        Start de keuzehulp
                                        <fa :icon="['fas', 'circle-play']" class="ml-2" />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div v-else class="relative">
                            <h1>
                                {{ category.title }}
                            </h1>
                            <p
                                v-html="category.description"
                                :class="{ 'pr-24 line-clamp-2 md:line-clamp-none': !showMore }"
                            ></p>
                        </div>
                        <span
                            class="md:hidden block absolute right-0 -bottom-0 text-blue-600"
                            v-if="!showMore"
                            @click="showMore = true"
                            >Lees meer</span
                        >
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-white w-full shadow-invert">
            <!-- <div class="bg-white w-full shadow-invert" :class="{ 'pt-4': headerImage }"> -->
            <category-filter
                :category="category"
                :children="children"
                :products="products"
                :options="options"
                :filter="filter"
                :counters="counters"
                :topCategories="topCategories"
                :showWizardSmall="showWizardSmall"
            />
        </div>

        <div class="w-full bg-gray-50">
            <div class="max-w-(--breakpoint-2xl) container mx-auto px-4 md:px-8 py-4">
                <div class="py-2 d-prose max-w-none">
                    <div class="mt-4 text-base text-gray-500" v-html="category.description_bottom"></div>
                </div>
            </div>
        </div>
    </main>
</template>

<script setup>
import Breadcrumbs from '@/Components/Breadcrumbs.vue';
import CategoryFilter from '@/Pages/Catalog/CategoryFilter.vue';
import { ref } from 'vue';

const showMore = ref(false);

// Memoize props
const props = defineProps({
    category: Object,
    children: [Object, Boolean],
    products: Object,
    options: Object,
    filter: [Object, Boolean],
    counters: Object,
    topCategories: Array,
    showWizardSmall: Boolean,
    headerImage: [Object, Boolean],
    showResource: Boolean,
    user: Object,
});

// Cache window check
const inBrowser = typeof window !== 'undefined';

// Optimize showWizard function
const showWizard = () => {
    if (inBrowser && window.mitt) {
        window.mitt.emit('open-wizard', true);
    }
};
</script>
